import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { Field } from 'formik';

import { defaultWelcomeTitle, defaultWelcomeContent } from '../wizard-builder';

export function WelcomeMessageSection() {
  return (
    <Accordion
      sx={{
        mb: 2,
        '&:before': {
          display: 'none',
        },
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: '8px !important',
        boxShadow: 'none',
        '&:hover': {
          bgcolor: 'action.hover',
        },
        '&.Mui-expanded': {
          my: '16px !important',
        },
      }}
    >
      <AccordionSummary
        expandIcon={<FontAwesomeIcon icon={faChevronDown} />}
        sx={{
          '&:hover': {
            bgcolor: 'rgba(0, 0, 0, 0.02)',
          },
          borderRadius: '8px',
          transition: 'background-color 0.2s ease',
        }}
      >
        <Typography variant="h6">Welcome Message</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Stack spacing={2}>
          <Field name="wizardWelcomeTitle">
            {({ field }: any) => (
              <TextField
                {...field}
                fullWidth
                label="Welcome Title"
                placeholder={defaultWelcomeTitle}
                helperText={`Default: "${defaultWelcomeTitle}"`}
              />
            )}
          </Field>

          <Field name="wizardWelcomeContent">
            {({ field }: any) => (
              <TextField
                {...field}
                fullWidth
                multiline
                rows={6}
                label="Welcome Content"
                placeholder={defaultWelcomeContent}
                helperText="Use bullet points (•) to create a list"
              />
            )}
          </Field>
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
}
